import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

// Obtener mis notificaciones
export const fetchMisNotificaciones = async (soloNoLeidas = false) => {
    try {
        const response = await axios.get(`${API_URL}/api/notificaciones/vacaciones`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            },
            params: { solo_no_leidas: soloNoLeidas }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Obtener contador de no leidas
export const fetchContadorNoLeidas = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/notificaciones/vacaciones/contador`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Marcar notificacion como leida
export const marcarNotificacionLeida = async (id) => {
    try {
        const response = await axios.put(`${API_URL}/api/notificaciones/vacaciones/${id}/leida`, {}, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

// Marcar todas como leidas
export const marcarTodasLeidas = async () => {
    try {
        const response = await axios.put(`${API_URL}/api/notificaciones/vacaciones/leidas`, {}, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};
